import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "../../lib/utils";

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  error?: string;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, error, className, id, ...rest },
  ref,
) {
  const generatedId = `input-${rest.name ?? Math.random().toString(36).slice(2, 8)}`;
  const inputId = id ?? generatedId;
  const errId = error ? `${inputId}-err` : undefined;
  return (
    <div className="space-y-1">
      {label ? (
        <label
          htmlFor={inputId}
          className="block text-xs text-[var(--ink-muted)]"
        >
          {label}
        </label>
      ) : null}
      <input
        ref={ref}
        id={inputId}
        aria-describedby={errId}
        aria-invalid={error ? "true" : undefined}
        className={cn(
          "w-full rounded-md border border-[var(--border)] bg-[var(--panel-soft)] px-3 py-2 text-sm text-[var(--ink)] placeholder:text-[var(--ink-faint)]",
          "focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--accent)] focus-visible:outline-offset-2",
          error ? "border-[var(--fail)]" : "",
          className,
        )}
        {...rest}
      />
      {error ? (
        <p id={errId} role="alert" className="text-xs text-[var(--fail)]">
          {error}
        </p>
      ) : null}
    </div>
  );
});
